import { lazy } from 'react';

export const LazyIntegrationCreateTemplatePage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--integration-create-template-page" */ './integration-create-template-page'
    ),
);
